export const isMobile = window.matchMedia('(max-width: 768px)').matches;
